import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getMySignature } from '../services/userSignatureService';

const useUserSignature = () => {
  const dispatch = useDispatch();
  const [signature, setSignature] = useState(null);
  const [signatureLoading, setSignatureLoading] = useState(false);

  const loadSignature = useCallback(() => {
    executeApiAction({
      setLoading: setSignatureLoading,
      dispatch,
      action: () => getMySignature(),
      onSuccess: (response) => setSignature(response),
    });
  }, [dispatch]);

  useEffect(() => {
    loadSignature();
  }, [loadSignature]);

  return {
    signature,
    signatureLoading,
    refetchSignature: loadSignature,
  };
};

export default useUserSignature;
